import { Divider } from '@chakra-ui/react';

export const nabanDetailsListCardContentProps = {
  divider: <Divider />,
  gap: {
    base: 0,
    md: 2,
  },
  py: {
    base: 2,
    md: 4,
  },
};
